import FormattedMessage from 'I18n/components/FormattedMessage';
import { DateRange } from 'foundations-components/transitional/components/DateRange';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { jsx as _jsx } from "react/jsx-runtime";
const ExportDateRange = ({
  dateRange,
  onChange
}) => /*#__PURE__*/_jsx(FormControl, {
  label: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "assetActionsLibForms.modals.exportSubmissions.dateRange"
  }),
  children: /*#__PURE__*/_jsx(DateRange, {
    onChange: ({
      target: {
        value: {
          startDate,
          endDate
        }
      }
    }) => {
      if (startDate && endDate) {
        onChange({
          startDate,
          endDate
        });
      }
    },
    value: dateRange
  })
});
export default ExportDateRange;